import {Fade, Grid, Icon, IconButton, ListItemIcon, Typography} from "@mui/material";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React from "react";
import {MenuItems} from "@/components/layout/types";
import {getRandomNumber} from "@/components/shared/client/utils";
import useStyles from "@/hooks/useStyles";
import Link from "next/link";

type CustomMenuProps = {
    items: MenuItems[],
    mainIcon: string,
    mainStyles?: {
        [key: string]: string
    }
}

const CustomMenu = (props: CustomMenuProps) => {
    const {items, mainIcon} = props;
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const {defaultFontSize, defaultFontFamily} = useStyles();

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return <Grid container className="df we1" sx={{...(props.mainStyles ?? {})}}>
        <IconButton
            aria-label="more"
            id="fade-button"
            aria-controls={open ? 'fade-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleClick}
        >
            <Icon>{mainIcon}</Icon>
        </IconButton>
        <Menu
            id="fade-menu"
            MenuListProps={{
                'aria-labelledby': 'fade-button',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            TransitionComponent={Fade}
            sx={{".material-icons": {fontSize: "1.2rem"}}}
        >
            {
                items.map((item: MenuItems) => {
                    return <Grid key={`m-${getRandomNumber({type: "uid"})}`} container
                                  sx={{width: "100%", display: item.doHide ? "none" : "flex"}}>
                        {!item.doHide &&
                            <MenuItem
                                component={item.link ? Link : null}
                                href={item.link ?? null}
                                sx={{...defaultFontFamily, ...defaultFontSize}}
                                onClick={() => {
                                    if(!item.link) {
                                        handleClose();
                                        item.onClick(item)
                                    }
                                }}
                            >
                                <ListItemIcon>
                                    <Icon>{item.icon}</Icon>
                                </ListItemIcon>
                                <Typography variant="inherit">{item.label}</Typography>
                            </MenuItem>}
                    </Grid>
                })
            }
        </Menu>
    </Grid>
}

export default CustomMenu;